<div>
  <div class="bold block">Tax Loss Harvesting</div>
  @if (!isTLHSetInGlobal) {
    <div class="block" style="border: 1px solid #C8C8C8; background-color:#F4F4F4;padding: 10px 20px;">
      <div class="block">This feature must be configured in iRebal settings before it can be turned on.</div>
      <div style="border:1px solid #C8C8C8;padding: 8px 6px 8px 12px;width:128px; background-color: #FFF;box-sizing: content-box;">
        <a (click)="openRebalanceGlobalSettings()">
          <img style="vertical-align: text-bottom;" src="/assets/images/shape.png" style="margin-right: 5px;vertical-align: text-bottom;">
          Go to Settings
          <img style="vertical-align: text-bottom;" src="/assets/images/chevron-right.png">
        </a>
      </div>
      <!--        This feature must be configured in iRebal Settings before it can be turned on. <a (click)="openRebalanceGlobalSettings()">-->
    <!--        Go to Settings</a>-->
  </div>
}

@if (isTLHSetInGlobal) {
  <div class="block">
    <div style="color:#848484;font-size:12px;">
      Should iRebal capture a capital loss for client portfolios that hold this security? These changes will apply in a tax loss harvest or tax loss harvest and full rebalance.
    </div>
    <div id="securityTLH" class="block">
      <p-radioButton [disabled]="!isTLHSetInGlobal" name="securityTLH" [value]="true"
      [(ngModel)]="isTlhEnabled" (ngModelChange)="setSecurityTLH(true)" inputId="tlhitem1"></p-radioButton>
      <label for="tlhitem1" style="padding-right: 12px;">On</label>
      <span>&nbsp;</span>
      <p-radioButton [disabled]="!isTLHSetInGlobal" name="securityTLH" [value]="false"
      [(ngModel)]="isTlhEnabled" (ngModelChange)="setSecurityTLH(false)" inputId="tlhitem2"></p-radioButton>
      <label for="tlhitem2">Off</label>
    </div>
    <div>
      <a class="show-help-learn-about-tlh" target="_blank" [href]="learnMoreUrl">
        <img src="../../assets/images/schwab-blue-popup.png" style="vertical-align: text-bottom;">
        Learn more about tax loss harvesting
      </a>
    </div>
  </div>
}

<div class="block" style="border-top: 1px solid #70818F;padding-top:10px;position:relative;" >
  @if (!equivalentSecurities) {
    <div class="loading-spinner wrapper-until-tlh-secs-ready "></div>
  }
  <div class="bold block">Wash Sale Alternatives</div>
  <div class="block" style="color:#848484;font-size:12px;">Wash sale alternatives will be applied whenever a transaction is subject to wash sale rules. Configure what iRebal should purchase with the proceeds of selling this security.</div>
  <div class="block" >
    <div class="bold">Primary</div>
    <div style="display: flex" id="wsa-primary">
      <irb-dropdown-filter #primaryWSFilter [(value)]="primaryWSTypeValue"
        (search)="getPrimaryWSForFilter($event)"
        (selection)="setPrimaryWSA($event.value)"
        size="40" hoverPanelWidth="321" class="wsa-type-primary-dropdown" style="margin-right: 10px;">
      </irb-dropdown-filter>

      @if (primaryWS==='sec') {
        <irb-dropdown-search
          #primarySecuritiesDropdownDropdown
          [addNewItem]="addNewSecurityItem"
          (openNewItemFlow)="openNewItemSecurityFlow($event, 'primarysecurity')"
          [(value)]="selectedPrimarySecurity"
          (search)="getPrimarySecuritiesDropdown($event)"
          (selection)="onPrimarySecurityChanged($event)"
          (clearSelection)="onClearSelection('primary')"
          placeholder="Enter symbol or company name"
          size="43" hoverPanelWidth="343">
        </irb-dropdown-search>
      }
    </div>
  </div>

  <div class="block">
    <div class="bold" [ngStyle]="{'opacity': (isSecondaryWSDisabled ? 0.5 : 1)}" >Secondary</div>
    <div style="display: flex" id="wsa-secondary">
      <irb-dropdown-filter #secondaryWSFilter [(value)]="secondaryWSTypeValue" [disabled]="isSecondaryWSDisabled"
        (search)="getSecondaryWSForFilter($event)"
        (selection)="setSecondaryWSA($event.value)"
        size="40" hoverPanelWidth="321" class="wsa-type-secondary-dropdown" style="margin-right: 10px;">
      </irb-dropdown-filter>

      @if (secondaryWS==='sec') {
        <irb-dropdown-search
          #secondarySecuritiesDropdownDropdown
          [addNewItem]="addNewSecurityItem"
          (openNewItemFlow)="openNewItemSecurityFlow($event, 'secondarysecurity')"
          [(value)]="selectedSecondarySecurity"
          (search)="getSecondarySecuritiesDropdown($event)"
          (selection)="onSecondarySecurityChanged($event)"
          (clearSelection)="onClearSelection('secondary')"
          placeholder="Enter symbol or company name"
          size="43" hoverPanelWidth="343">
        </irb-dropdown-search>
      }
    </div>
  </div>

  <a class="show-help-learn-about-wsa" (click)="onClickWashSaleHowTo();">
    <img src="../../assets/images/schwab-blue-popup.png" style="vertical-align: text-bottom;">
    Learn more about how iRebal handles wash sales
  </a>
</div>
</div>
